import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import config from '../config.js'

import {fetchDataIfReady} from 'Skelet/src/modules/fetch.action.js'
import {handleChange} from 'Skelet/src/modules/functions.js'
import ModalWrapper from 'Skelet/src/components/Modal_Wrapper.js'


class ModalCreateJourney extends React.Component {

  constructor(props) {
    super(props);

    this.state = {start_weight:"", start_date:"", goal_weight:"", goal_date:""};
  }

  componentWillReceiveProps(nextProps) {
    let now = new Date();
    let start_date = now.getFullYear()+"-"+('0'+(now.getMonth()+1)).slice(-2)+"-"+('0'+now.getDate()).slice(-2);
    this.handleStartDateChange("start_date", start_date)
  }

  setStartWeight(start_date = false) {
    if(!start_date) start_date = this.state.start_date;
    let start_weight = "";
    let sizes = this.props.apiData["sizes_list"];
    if(sizes !== undefined && !sizes.isFetching && sizes.data !== [] && sizes.data[0]) {
      sizes.data.find(function(size) {
        if(size.date === start_date) start_weight = ""+size.weight;
        return size.date === start_date;
      });
      this.setState({start_weight:start_weight.toString().replace(".", ",")});
    }
  }

  render() {
    if(this.props.shouldShow) {
      const d = new Date(this.state.start_date);
      const start_date_offset = d.getTime()+(86400000*20);
      const valid_date = start_date_offset <= Date.parse(this.state.goal_date);
      const submit_disabled = this.state.start_weight.trim() === "" || this.state.start_date.trim() === "" || this.state.goal_weight.trim() === "" || this.state.goal_date.trim() === "";

      return (
        <ModalWrapper switchState={this.props.close}>
          <form onSubmit={(e) => {e.preventDefault();this.submitForm()}}>
            <div><input type="text" value={this.state.start_weight} onChange={(e) => handleChange(this, "start_weight", e)} maxLength="7" placeholder="Startgewicht" autoFocus /></div>
            <div><input type="date" value={this.state.start_date} onChange={(e) => this.handleStartDateChange("start_date", e)} maxLength="10" placeholder="JJJJ-MM-DD" /></div>
            <div><input type="text" value={this.state.goal_weight} onChange={(e) => handleChange(this, "goal_weight", e)} maxLength="7" placeholder="Streefgewicht" /></div>
            <div><input type="date" value={this.state.goal_date} onChange={(e) => handleChange(this, "goal_date", e)} maxLength="10" placeholder="JJJJ-MM-DD" /></div>
            {this.state.goal_date.trim() !== "" && !valid_date && <div><small>Ongeldige datum, maak een plan dat minstens drie weken duurt.</small></div>}
            <div><input type="submit" value="toevoegen" disabled={submit_disabled} /></div>
          </form>
        </ModalWrapper>
      );
    } else {
      return null;
    }
  }

  handleStartDateChange(state_name, e) {
    let newState = {};
    newState[state_name] = (typeof e.target !== "undefined") ? e.target.value : e;
    this.setState(newState);
    this.setStartWeight(newState.start_date);
  }

  submitForm() {
    const {start_weight, start_date, goal_weight, goal_date} = this.state;
    const submit_disabled = start_weight.trim() === "" || start_date.trim() === "" || goal_weight.trim() === "" || goal_date.trim() === "";
    if(!submit_disabled) {
      let start_weight_float = parseFloat(start_weight.toString().replace(",", "."));
      let goal_weight_float = parseFloat(goal_weight.toString().replace(",", "."));
      if(!isNaN(start_weight_float) && !isNaN(goal_weight_float)) {
        this.props.fetchDataIfReady(config.api_token, "bin", "POST", config.api_url+"/journey", JSON.stringify({session_token:this.props.session_token, start_weight:start_weight_float, start_date, goal_weight:goal_weight_float, goal_date}), null, true, false, true, false, false, null, "journey_list");
        this.props.close();
        this.setState({start_weight:"", start_date:"", goal_weight:"", goal_date:""});
      }
    }
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreateJourney)



// WEBPACK FOOTER //
// ./src/containers/ModalCreateJourney.js